module.exports = __webpack_public_path__ + "img/img17.897d873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img17.png
// module id = 193
// module chunks = 0